import React from 'react';
import PropTypes from 'prop-types';
import Button from '@welldev-group/rcl-button';
import Icon from '@welldev-group/rcl-icon';
import SanitizedHTML from 'sharedWebpack/SanitizedHTML';
import classNames from 'classnames';

const Error = ({ error, onModalClose, children, isWithAction, className }) => {
  const { header, message } = error;

  return (
    <div className={classNames('d-flex direction-column align-center row-gap-20', className)}>
      <div className="d-flex direction-column align-center row-gap-16">
        <Icon name="invalidOutline" size="medium" color="danger" showBGColor={true} />
        <div className="issue-booking-modal__header">{header}</div>
        <SanitizedHTML className="issue-booking-modal__subheader" html={message} />
      </div>
      {children ||
        (!isWithAction && (
          <Button
            label={I18n.t('admin.order_items.issue_ticket.close')}
            size="small"
            version="v2"
            onClick={onModalClose}
          />
        ))}
    </div>
  );
};

Error.defaultProps = {
  children: null,
  isWithAction: false,
  onModalClose: () => {},
  className: '',
};

Error.propTypes = {
  error: PropTypes.shape({
    header: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
  onModalClose: PropTypes.func,
  children: PropTypes.node,
  isWithAction: PropTypes.bool,
  className: PropTypes.string,
};

export default Error;
